module.exports = __webpack_public_path__ + "img/dokumen_perusahaan.321393a8.png";